import { createContext } from 'react';
export const initialState = {
  nsAndRecords: true,
  webForwards: true,
  mailboxes: true
};
export const ReadOnlyContext = /*#__PURE__*/createContext({
  setReadOnly: () => {},
  toggleReadOnly: () => {},
  // non-existing section must be readonly
  sections: initialState
});